import { render, staticRenderFns } from "./TuitionStudent.vue?vue&type=template&id=778a27cf&"
import script from "./TuitionStudent.vue?vue&type=script&lang=js&"
export * from "./TuitionStudent.vue?vue&type=script&lang=js&"
import style0 from "./TuitionStudent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports